import React from "react";
import { useLocalization } from "@i18n";
import { GeneralReadOnlyFieldsModal } from "./GeneralReadOnlyFieldsModal";
import { ALL_DAM_GEOMETRY_FIELDS } from "../../utils/generalFieldConfigs";
import { FieldItem } from "../GeneralDashboardFieldGrid";

interface GeneralGeometryDetailsModalProps {
  open: boolean;
  onClose: () => void;
  data: Record<string, unknown> | null;
}

export const GeneralGeometryDetailsModal: React.FC<GeneralGeometryDetailsModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const { translate } = useLocalization();

  const fields: FieldItem[] = ALL_DAM_GEOMETRY_FIELDS.map((field) => ({
    labelKey: field.labelKey,
    value: data ? data[field.name] : null,
  }));

  return (
    <GeneralReadOnlyFieldsModal
      open={open}
      onClose={onClose}
      title={translate("general.dashboard.geometry.modalTitle")}
      fields={fields}
    />
  );
};
